export default {
    signature: state => state.signature,
    content: state => state.content,
    term: state => state.term,
    teacher: state => state.teacher,
    institution: state => state.institution,
    loading: state => state.loading,
    error: state => state.error,
    isTokenExpired: state => state.error && state.error.code === 'TOKEN_EXPIRED',
    isTokenInvalid: state => state.error && state.error.code === 'TOKEN_INVALID',
    isAlreadySigned: state => state.signature && state.signature.term_signature_status_id === 2,
}
